import React, { useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Alert,
} from "@mui/material";
import { DEFAULT_BATCH_YEAR, BATCH_OPTIONS } from "../../config";
import Banner from "../Common/Banner";
import { useNavigate } from "react-router-dom";
import api from "../Auth/Middleware";

const classOptions = [
  { value: 5, label: "5th" },
  { value: 6, label: "6th" },
  { value: 7, label: "7th" },
  { value: 8, label: "8th" },
  { value: 9, label: "9th" },
  { value: 10, label: "10th" },
  { value: 11, label: "11th" },
  { value: 12, label: "12th" },
];

const Courses = {
  Maths: 1,
  Science: 2,
  Physics: 3,
  Chemistry: 4,
  English: 5,
};

const coursesByClass = {
  5: [Courses.Maths, Courses.Science, Courses.English],
  6: [Courses.Maths, Courses.Science, Courses.English],
  7: [Courses.Maths, Courses.Science, Courses.English],
  8: [Courses.Maths, Courses.Science, Courses.English],
  9: [Courses.Maths, Courses.Science, Courses.English],
  10: [Courses.Maths, Courses.Science, Courses.English],
  11: [Courses.Maths, Courses.Physics, Courses.Chemistry],
  12: [Courses.Maths, Courses.Physics, Courses.Chemistry],
};

const intialStudentData = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  class: "",
  fatherName: "",
  studentContact: "",
  parentContact: "",
  school: "",
  address: "",
  courses: [],
  dateOfAdmission: "",
  batchYear: DEFAULT_BATCH_YEAR,
};
const AddStudent = () => {
  const [studentData, setStudentData] = useState(intialStudentData);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogContent, setDialogContent] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setStudentData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClassChange = (event) => {
    const selectedClass = event.target.value;
    setStudentData((prevData) => ({
      ...prevData,
      class: selectedClass,
      courses: [],
    }));
  };

  const validateMobileNumber = (mobileNumber) => {
    if (mobileNumber === "") {
      return true;
    }
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobileNumber);
  };

  const handleCourseChange = (event) => {
    const selectedCourses = Array.from(event.target.value);
    const selectedClass = studentData.class;
    const availableCourses = coursesByClass[selectedClass] || [];
    const filteredCourses = selectedCourses.filter((course) =>
      availableCourses.includes(course)
    );

    setStudentData((prevData) => ({
      ...prevData,
      courses: filteredCourses,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post("Student/AddStudent", studentData);
      if (response.status === 200) {
        setIsSuccess(true);
        setDialogTitle("Student Added Successfully");
        setDialogContent([response.data]);
        setDialogOpen(true);
      } else {
        setIsSuccess(false);
        setDialogTitle("Error occured");
        setDialogContent(response.data);
        setDialogOpen(true);
      }
    } catch (error) {
      setIsSuccess(false);
      setDialogTitle("API Error");
      setDialogContent("An error occurred while processing the request.");
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    navigate("/adminDashboard");
  };
  const handleAddMoreDialog = () => {
    setStudentData(intialStudentData);
    setDialogOpen(false);
  };
  const handleTryAgainDialog = () => {
    setDialogOpen(false);
  };

  const handleReset = () => {
    setStudentData(intialStudentData);
  };

  const headers = Object.keys(dialogContent[0] || {});

  return (
    <>
      <Banner title="Add Student" currentpage="Add Student" previousPage = "Admin Dashboard" link="/adminDashboard"/>
      <div className="container-fluid my-5 d-flex align-items-center justify-content-center">
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <div className="card shadow-sm p-4">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Currently enrolling student in batch <strong>{studentData.batchYear}</strong>
                  </Alert>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="First Name"
                        name="firstName"
                        required
                        fullWidth
                        value={studentData.firstName}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Last Name"
                        name="lastName"
                        required
                        fullWidth
                        value={studentData.lastName}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Date of Birth"
                        name="dateOfBirth"
                        required
                        type="date"
                        fullWidth
                        value={studentData.dateOfBirth}
                        onChange={handleInputChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Date of Admission"
                        name="dateOfAdmission"
                        required
                        type="date"
                        fullWidth
                        value={studentData.dateOfAdmission}
                        onChange={handleInputChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id="class-label">Class</InputLabel>
                        <Select
                          labelId="class-label"
                          label="Class"
                          name="class"
                          required
                          value={studentData.class}
                          onChange={handleClassChange}
                        >
                          {classOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Father's Name"
                        name="fatherName"
                        required
                        fullWidth
                        value={studentData.fatherName}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id="courses-label">Courses</InputLabel>
                        <Select
                          labelId="courses-label"
                          multiple
                          label="Courses"
                          required
                          value={studentData.courses}
                          onChange={handleCourseChange}
                          disabled={studentData.class === ""}
                          renderValue={(selected) => selected.join(", ")}
                        >
                          {(coursesByClass[studentData.class] || []).map(
                            (course) => (
                              <MenuItem key={course} value={course}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={studentData.courses.includes(
                                        course
                                      )}
                                    />
                                  }
                                  label={Object.keys(Courses).find(
                                    (key) => Courses[key] === course
                                  )}
                                />
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Student Contact"
                        name="studentContact"
                        required
                        fullWidth
                        value={studentData.studentContact}
                        onChange={handleInputChange}
                        inputProps={{
                          minLength: 10,
                          maxLength: 10,
                          pattern: "^[6-9]\\d{9}$",
                        }}
                        error={
                          !validateMobileNumber(studentData.studentContact)
                        }
                        helperText="Please enter a valid 10-digit mobile number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Parent Contact"
                        name="parentContact"
                        required
                        fullWidth
                        value={studentData.parentContact}
                        onChange={handleInputChange}
                        inputProps={{
                          minLength: 10,
                          maxLength: 10,
                          pattern: "^[6-9]\\d{9}$",
                        }}
                        error={!validateMobileNumber(studentData.parentContact)}
                        helperText="Please enter a valid 10-digit mobile number"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="School"
                        name="school"
                        required
                        fullWidth
                        value={studentData.school}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Address"
                        name="address"
                        required
                        fullWidth
                        value={studentData.address}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id="batch-year-label">Batch Year</InputLabel>
                        <Select
                          labelId="batch-year-label"
                          label="Batch Year"
                          name="batchYear"
                          required
                          value={studentData.batchYear}
                          onChange={handleInputChange}
                        >
                          {BATCH_OPTIONS.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Button type="submit" variant="contained" color="primary">
                        Add Student
                      </Button>
                      <Button
                        sx={{ margin: "1rem 2rem" }}
                        type="reset"
                        onClick={handleReset}
                        variant="contained"
                        color="secondary"
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dialogContent.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {headers.map((header, colIndex) => (
                    <TableCell key={colIndex}>{row[header]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </DialogContent>
        <DialogActions>
          {isSuccess ? (
            <Button onClick={handleAddMoreDialog} color="primary">
              Add More
            </Button>
          ) : (
            <Button onClick={handleTryAgainDialog} color="primary">
              Try Again
            </Button>
          )}
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddStudent;
